import Menu from '@material-ui/core/Menu'
import { Box } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { NestedMenuItem } from 'components/base/NestedMenu'
import MenuItem from 'components/base/MenuItem'
import React, { useContext, useRef } from 'react'
import { noop } from 'lodash'
import { TranslationContext } from 'contexts/TranslationContext'
import { useOnClickWithoutPropagation } from '~/hooks'
import { ReactComponent as Expand } from '~/assets/media/menu_expand.svg'
import { NW_JS_APP_PROFILES, FILE_STATUS } from '~/enums'
import Divider from '~/components/base/Divider/Divider'

const EMPTY = () => {}

const StyledMenu = styled(Menu)({
  '&': {
    pointerEvents: 'none',
  },
  '& .MuiList-root': {
    padding: '5px 0px',
    pointerEvents: 'auto',
  },
  '& .MuiMenu-paper': {
    borderRadius: '4px',
  },
})

/**
 *
 * @param {*} param0
 * @returns
 */
export const MediaItemMenu = ({
  asset,
  open,
  onClose,
  anchorEl,
  isFolder = false,
  isTopLayer = false,
  showSettings = false,
  showNabletHld = false,
  showTranscribe = false,
  showMoveTo = false,
  useRemove = true,
  onClickMoveFiles = EMPTY,
  onClickShowSettings = EMPTY,
  onClickMoveToMedia = EMPTY,
  onClickDeleteMedia = EMPTY,
  onClickCopyUrl = EMPTY,
  onBrowseOutput = EMPTY,
  onClickNabletHld = EMPTY,
  onClickTranscribe = EMPTY,
  onAddSourceFileByFrameTimeCode = noop,
  menuPositionCoords,
}) => {
  const menuRef = useRef()
  const handleClick = useOnClickWithoutPropagation(onClose)
  const stopPropagation = useOnClickWithoutPropagation()
  const { t } = useContext(TranslationContext)

  const renderMoveItemsTo = () => (
    (
      <NestedMenuItem
        key="nested_menu"
        label={t('MEDIA_MENU_LABEL_MOVE_TO')}
        parentMenuOpen={open}
        rightIcon={<Expand />}
      >
        <MenuItem onClick={onClickMoveToMedia}>{t('MEDIA_MENU_ITEM_MEDIA')}</MenuItem>
        <MenuItem onClick={onClickMoveFiles}>{t('MEDIA_MENU_ITEM_SELECT_FOLDER')}</MenuItem>
      </NestedMenuItem>
    )
  )

  return (
    <>
      <StyledMenu
        ref={menuRef}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: menuPositionCoords?.y ?? 0,
          left: menuPositionCoords?.x ?? 0,
        }}
        PaperProps={{ square: true }}
        disableAutoFocus
        disableAutoFocusItem
        disableEnforceFocus
        disableRestoreFocus
        disableBackdropClick
        open={open}
        onClose={onClose}
        onClick={handleClick}
        onMouseUp={stopPropagation}
      >
        <Choose>
          <When condition={isTopLayer}>
            <If condition={showMoveTo}>
              <MenuItem onClick={onClickMoveFiles}>
                {t('MEDIA_MENU_ITEM_MOVE_TO')}
                ...
              </MenuItem>
            </If>
          </When>
          <Otherwise>
            {renderMoveItemsTo()}
          </Otherwise>
        </Choose>
        <If condition={!isFolder && showSettings}>
          <MenuItem onClick={onClickShowSettings}>
            {t('MEDIA_MENU_ITEM_SETTINGS')}
          </MenuItem>
        </If>
        <If condition={!isFolder}>
          <Choose>
            <When condition={NW_JS_APP_PROFILES.includes(__APP_PROFILE__)}>
              <MenuItem onClick={onBrowseOutput}>
                {t('MEDIA_MENU_ITEM_BROWSE_MEDIA')}
              </MenuItem>
            </When>
            <Otherwise>
              <MenuItem onClick={onClickCopyUrl}>
                {t('MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS')}
              </MenuItem>
            </Otherwise>
          </Choose>

          <If condition={[
            FILE_STATUS.READY, FILE_STATUS.PREPARE_THUMBNAILS,
          ].includes(asset.status)}
          >
            <MenuItem onClick={onAddSourceFileByFrameTimeCode}>
              {t('MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE')}
            </MenuItem>
          </If>
          <If condition={showNabletHld}>
            <MenuItem onClick={onClickNabletHld}>
              {t('MEDIA_MENU_ITEM_NABLET_HLD')}
            </MenuItem>
          </If>
          <If condition={showTranscribe}>
            <MenuItem onClick={onClickTranscribe}>
              {t('MEDIA_MENU_ITEM_TRANSCRIBE')}
            </MenuItem>
          </If>
          <If condition={useRemove}>
            <Box padding="5px 0"><Divider /></Box>
            <MenuItem onClick={onClickDeleteMedia} data-id="delete">
              {t('MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS')}
            </MenuItem>
          </If>
        </If>
      </StyledMenu>
    </>
  )
}
